export default __webpack_public_path__ + "static/7_25-96bcccf61254b249cbf74078fb4ae0b5.png";